import React from "react";
import { Trans, useTranslation } from "react-i18next";
import * as SC from "./CreditModal.styled";

import InvoiceAddressSelector from "../SelfServiceCampaignCreation/Campaign__Create_InvoiceAddressSelector.jsx";
import { Button as BtnPrimary } from "@talentbait/shared-components";
import { formatIntlNumber, numberFormat } from "../../utils/Helpers.js";

// Component shown for the review step of the credit purchasing
const ReviewStep = ({
  selectedPrepaidPackageId,
  selectedPackageData: { id, name, discount, prepaidMoney },
  uploadCredit,
  goBack,
  disabled,
  currentlySelectedAddress,
  selectedInvoiceEmail,
  selectedInvoiceAddressData,
  poNumber,
  setPONumber,
  language
}) => {
  const { t } = useTranslation();

  // Calculate how much discount the client is getting in EUR
  let discountAmount = (prepaidMoney * discount) / 100;
  discountAmount =
    discountAmount.toFixed(2) == discountAmount ? discountAmount : discountAmount.toFixed(2);
  // Calculate how much tax would be added to the final amount
  const taxAmount = (prepaidMoney - discountAmount) * 0.19;
  return (
    <SC.ModalContentWrapper className="fade-in">
      <SC.Header>{t("Please review your selection")}</SC.Header>
      <SC.PackagesSection>
        <SC.SinglePackageCard selected={id == selectedPrepaidPackageId} key={id}>
          <SC.SinglePackageCardDetailSeciton>
            <SC.SinglePackageCardDetailLeftSection>
              <SC.SinglePackageCardRadio type="radio" checked={id == selectedPrepaidPackageId} />
              <SC.SinglePackageCardDetailLeftNameSection>
                <SC.SinglePackageCardTitle>
                  <Trans>{name}</Trans>
                </SC.SinglePackageCardTitle>
                <SC.SinglePackageCardSavingsPercent>
                  {t("You save")} {formatIntlNumber(discount, { language })}%
                </SC.SinglePackageCardSavingsPercent>
              </SC.SinglePackageCardDetailLeftNameSection>
            </SC.SinglePackageCardDetailLeftSection>
            <SC.SinglePackageCardDetailSavingsSection>
              <SC.SinglePackageCardSubtitle>{t("You save")}</SC.SinglePackageCardSubtitle>
              <SC.SinglePackageCardAmount>
                {formatIntlNumber(discountAmount, { language })} €
              </SC.SinglePackageCardAmount>
            </SC.SinglePackageCardDetailSavingsSection>
          </SC.SinglePackageCardDetailSeciton>
          <SC.SinglePackageCardTotalSeciton>
            <SC.SinglePackageCardSubtitle>{t("Total")}</SC.SinglePackageCardSubtitle>
            <SC.SinglePackageCardAmount>
              {formatIntlNumber(prepaidMoney, { language })} €
            </SC.SinglePackageCardAmount>
          </SC.SinglePackageCardTotalSeciton>
        </SC.SinglePackageCard>
      </SC.PackagesSection>
      <SC.InvoiceSelectorSection>
        {t("Billing address")}:
        <br />
        <br />
        <InvoiceAddressSelector
          invoiceAddresses={[currentlySelectedAddress]}
          onSelectAddress={() => {}}
          currentlySelectedAddress={currentlySelectedAddress}
          direction="top"
          disabled={true}
          selectedInvoiceEmail={selectedInvoiceEmail}
          selectedInvoiceAddressData={selectedInvoiceAddressData}
        />
        <SC.SingleFieldWrapper>
          <div style={{ width: "100%" }}>
            <SC.LabelSection>{t("PO number")}:</SC.LabelSection>
          </div>
          <div style={{ width: "100%" }}>
            <SC.Input
              type="text"
              style={{
                position: "relative",
                left: "5px",
                height: "40px",
                lineHeight: "40px",
                paddingLeft: "10px",
                width: "calc(100% - 5px)"
              }}
              value={poNumber}
              onChange={(event) => {
                setPONumber(event.target.value);
              }}
              placeholder={t("PO number") + ` (${t("optional")})`}
            />
          </div>
        </SC.SingleFieldWrapper>
      </SC.InvoiceSelectorSection>
      <SC.PriceBreakdownSection>
        <SC.PriceBreakdownSingleItem>
          <strong>{t("Budget (net)")}:</strong>
          <span>{formatIntlNumber(prepaidMoney, { language })} €</span>
        </SC.PriceBreakdownSingleItem>
        <SC.PriceBreakdownSingleItem>
          <strong>{t("Discount")}:</strong>
          <span>-{formatIntlNumber(discountAmount, language)} €</span>
        </SC.PriceBreakdownSingleItem>
        <SC.PriceBreakdownSingleItem>
          <strong>
            {t("VAT 19% from")} {formatIntlNumber(prepaidMoney - discountAmount, { language })} €:
          </strong>
          <span>{formatIntlNumber(taxAmount, { language })} €</span>
        </SC.PriceBreakdownSingleItem>
        <SC.PriceBreakdownSingleItem>
          <strong>{t("Total")}</strong>
          <span>{formatIntlNumber(prepaidMoney - discountAmount + taxAmount, { language })} €</span>
        </SC.PriceBreakdownSingleItem>
      </SC.PriceBreakdownSection>
      <div
        style={{
          position: "relative",
          top: "-5px",
          display: "flex",
          flexDirection: "row-reverse",
          marginTop: "40px"
        }}
      >
        <BtnPrimary type="primary" onClick={uploadCredit} disabled={disabled}>
          {t("Top up now")}
        </BtnPrimary>
        <div style={{ marginRight: "10px" }}>
          <BtnPrimary type="tertiary" variant="outline" onClick={() => goBack()}>
            {t("Back")}
          </BtnPrimary>
        </div>
      </div>
    </SC.ModalContentWrapper>
  );
};
export default ReviewStep;
